import {useState} from 'react';
import {Button, Input, Row} from 'antd';
import {insertBatchNote} from "../../api/Api";
import {BATCH_NOTES_MAX_LENGTH} from "../../api/Constants";
import {handleNoSession} from "../../util/errorUtils";

const {TextArea} = Input;

export const NewBatchNotesWidget = ({batch, io, props}) => {
    const [notes, setNotes] = useState(undefined);
    const {onRefresh, onApiFail} = io;

    const clearForm = () => {
        setNotes(undefined);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onClick = () => {
        insertBatchNote(batch.id, notes).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            handleNoSession(e, onApiFail);
        }).finally(() => {
            clearForm();
        })

    }

    const rowStyle= {
        marginTop: '5px', marginBottom: '10px'
    }

    const okDisabled=(notes === undefined) || (notes.length === 0)

    return <div>
        <Row style={rowStyle}>
            <TextArea value={notes} placeholder={`new notes`} rows={6} maxLength={BATCH_NOTES_MAX_LENGTH} showCount onChange={onNotesChange}/>
        </Row>
        <Row>
            <Button onClick={onClick} disabled={okDisabled}>Ok</Button>
        </Row>
    </div>
}